import { Field, Input as HUInput } from '@headlessui/react'
import debounce from 'lodash/debounce'
import { InputHTMLAttributes } from 'react'
import styled from 'styled-components'

import { Label } from '@/components/Label.tsx'
import { BodyS } from '@/components/Text.tsx'
import { textSizeM } from '@/styles/theme/fonts.ts'

export const InputStyled = styled(HUInput)`
  border: 1px solid
    ${({ invalid, theme }) =>
      invalid ? theme.colors.common.alert : theme.colors.common.border};
  background-color: ${({ theme }) => theme.colors.common.white};
  color: ${({ theme }) => theme.colors.common.black75};
  padding: 17px;
  border-radius: 10px;
  width: 100%;
  min-height: 48px;
  ${textSizeM};
`

export const ErrorMessage = styled(BodyS)`
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.common.alert};
`

const InputWrapper = styled(Field)`
  display: flex;
  flex-direction: column;
`

export const Input = ({
  className,
  errorMessage,
  label,
  ...inputProps
}: {
  label?: string
  errorMessage?: string
} & InputHTMLAttributes<HTMLInputElement>) => (
  <InputWrapper className={className}>
    <Label htmlFor={inputProps.name}>{label}</Label>
    <InputStyled {...inputProps} invalid={!!errorMessage} />
    {!!errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
  </InputWrapper>
)

export const DebouncedInput = ({
  debounceTimeout = 500,
  onChange,
  ...props
}: {
  debounceTimeout?: number
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'>) => {
  const handleChange = debounce((e) => {
    onChange(e)
  }, debounceTimeout)

  return <Input {...props} onChange={handleChange} />
}
